import { render, staticRenderFns } from "./seatShareList.vue?vue&type=template&id=ca65e740"
import script from "./seatShareList.vue?vue&type=script&lang=js"
export * from "./seatShareList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports